import {NgModule} from '@angular/core';
import {COMPONENTS, COMPONENTS_EXPORTS, SERVICES} from './index';
import {CoreModule} from '../../core/core.module';
import {SharedModule} from "@ispm/shared/shared.module";
import {ClickOutsideModule} from "ng-click-outside";
import {DynamicFormModule} from "@ispm/dynamic-form/dynamic-form.module";
import {AccordionModule} from 'primeng/accordion';
import {SharedModule as PNGShared} from 'primeng/api';

@NgModule({
  imports: [
    CoreModule,
    SharedModule,
    ClickOutsideModule,
    DynamicFormModule,
    AccordionModule,
    PNGShared
  ],
  declarations: [...COMPONENTS],
  providers: [...SERVICES],
  exports: [...COMPONENTS_EXPORTS]
})

export class DashboardMenuModule {
}


